import {BaseService} from "./Core/BaseService";

class SavedQueryService extends BaseService {
    get Url() { return super.Url + "/savedQueries"; }

    Get() {
        return this.SendRequest(BaseService.GET);
    }

    UpdateSavedQuery(savedQuery) {
        return this.SendRequest(BaseService.PUT, savedQuery);
    }

    CreateSavedQuery(savedQuery) {
        return this.SendRequest(BaseService.POST, savedQuery);
    }

    DeleteSavedQuery(savedQueryId) {
        return this.SendRequest(BaseService.DELETE, savedQueryId);
    }
}

export const service = new SavedQueryService();

